import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomerProfileService {
  private validateCustProfile = new BehaviorSubject<string>('');
  $validateCustProfile = this.validateCustProfile.asObservable();

  private timeFrameFor5Months = new Subject<boolean>();
  private timeFrameForRenewalDue30Days = new Subject<boolean>();
  private timeFrameModal = new Subject<string>();

  setModalTitle(value) {
    this.validateCustProfile.next(value);
  }
  setTimeFrameModal(value) {
    this.timeFrameModal.next(value);
  }
  setTimeFrameFor5Months(value) {
    this.timeFrameFor5Months.next(value);
  }
  setTimeFrameForRenewalDue30Days(value) {
    this.timeFrameForRenewalDue30Days.next(value);
  }
  getTimeFrameModal() {
    return this.timeFrameModal.asObservable();
  }
  getTimeFrameFor5Months() {
    return this.timeFrameFor5Months.asObservable();
  }
  getTimeFrameForRenewalDue30Days() {
    return this.timeFrameForRenewalDue30Days.asObservable();
  }
  getModalTitle() {
    return this.validateCustProfile.asObservable();
  }
  clearTimeFrameFor5Months() {
    this.timeFrameFor5Months.next(null);
  }
  clearTimeFrameForRenewalDue30Days() {
    this.timeFrameForRenewalDue30Days.next(null);
  }
  clearModalTitle() {
    this.validateCustProfile.next('');
  }
  clearTimeFrameModal() {
    this.timeFrameModal.next('');
  }
}
export interface CPData {
  daysSinceLastLogin: number;
  daysSinceLastSnooze: number;
}
